import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { Rdvs } from '@shared/services/rdvs/models';

@Injectable({ providedIn: 'root' })
export class RdvsService extends ApiServiceBase<Rdvs> {
  constructor() {
    super('rdvs', 'rdvs', 'fournierWebservice');
  }
}
